import { trackSubscriptionStateChanged, type CancellationTypeLabel } from '@/analytics/events'
import { useSubscriptionStore } from '@/store/subscription'

/**
 * `SubscriptionStateChanged` for a cancel call (CR 77): the plan is read now, before the call — `from`
 * must be the state it leaves — and the returned sender is called once the backend accepted it. Every
 * exit that changes the plan sends one: /cancel/confirm, "Keep my plan", the instalments, the fee, the
 * refund, "Cancel after my current plan ends", "renewals only" under review. A buy-out after "Keep my
 * plan" is a second one, from `cancelled`.
 */
export function stateChangeOnCancel(cancellationType: CancellationTypeLabel): () => void {
	const store = useSubscriptionStore()
	const s = store.checkStatus
	const from = s.isCancelled ? 'cancelled' : s.isPaused ? 'paused' : s.isActive ? 'active' : undefined
	const sub = store.subscription
	const phase = store.getActivePhase ?? store.getPhases.regular
	const payload = {
		subscription_type: store.checkPeriodType.isTrial ? 'trial' : 'subscription',
		provider: sub?.provider,
		product_id: sub?.product_id,
		payment_method: sub?.payment_method,
		subscription_duration:
			phase?.interval_duration && phase?.interval_unit
				? `${phase.interval_duration} ${phase.interval_unit}`
				: undefined,
		from,
		to: 'cancelled',
		cancellation_type: cancellationType,
	}
	return () => trackSubscriptionStateChanged(payload)
}
